import '@babel/polyfill';
import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import gsap from 'gsap';
import slick from 'slick-carousel';
import objectFitImages from 'object-fit-images';
import objectFitVideos from 'object-fit-videos';

svg4everybody();
objectFitImages();
objectFitVideos();

window.$ = $;
window.jQuery = $;
window.gsap = gsap;
window.slick = slick;
window.objectFitVideos = objectFitVideos;
window.objectFitImages = objectFitImages;

require('ninelines-ua-parser');
